class @App.Components.TodosList
  constructor: ->
    @$element = $('[data-component="todos"]')
    @$elementParent = @$element.parent()
    @$todosContainer = @$element.find '.teded-todos--sidebar'
    @$counter = $('[data-component="todosCounter"]')

    @updateCounter()

    @$element.on 'change.todoslist', '[data-component="todosCheck"]', (e) =>
      $target = $(e.target)
      isComplete = $target.prop('checked')
      @updateToDoItem $target.closest('[data-component="todosItem"]'), isComplete
      @sendAPICall $target.val(), isComplete
      @updateCounter()
      return

    $('body').on 'click.todoslist', '[data-action="todos-open"]', (e) =>
      @$element.fadeIn()
      return

    $('body').on 'click.todoslist', '[data-action="todos-close"]', (e) =>
      @$element.fadeOut () =>
        @$element.css
          display: ''
          opacity: ''
      return

    $(window).on 'teded_subnav_page_changing', (e, activePageId) =>
      @updateContainerPage activePageId
      return

  updateContainerPage: (activePageId) =>
    $activePage = $(activePageId)
    $activePageContent = $activePage.find '.teded-page__content'

    @$elementParent.insertAfter $activePageContent
    return

  updateCounter: =>
    items = @$element.find('[data-component="todosItem"][data-status="pending"]').length
    @$counter.text(items)
    return

  updateToDoItem: ($item, isComplete) ->
    $checkmark = $item.find('[data-action="check"]')
    status = if isComplete then 'complete' else 'pending'
    $item.data('status', status).attr('data-status', status)
    return

  sendAPICall: (todo_id, isComplete) ->
    ajax_url = "/student_talks/application_todos/#{todo_id}" +
               "?clubs_application_todo[completed]=" +
               if isComplete then '1' else '0'
    $.ajax
      type: 'patch'
      dataType: 'json'
      url: ajax_url
    return

$ ->
  new App.Components.TodosList if $('[data-component="todos"]')
